import React from 'react';
import { asyncConnect } from 'ha/modules/ReduxConnect';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { loadHermesData } from 'ha/modules/Hermes';
import { getFavoriteListings } from 'ha/modules/FavoriteListing';
import EXPERIMENTS from 'ha/constants/experiments';
import { Experiment, Variant } from 'ha/modules/Experiments';

import getSearchAlert from '../actions/getSearchAlert';
import {
  load,
  initialize,
  trackFilterApplied,
  getCollectionStats,
  loadAdvertiser,
  toggleMobileMap,
} from '../actions';
import {
  getPageName,
  getAnalyticsForListings,
  getAnalyticsForFilters,
  getSearchParams,
  getErrorState,
  getCityCanonical,
  getCountryCode,
  isNotFound,
  getPreviewNumberOfListings,
  isSuggestionBarVisible,
} from '../selectors';
import { collectionToFilters } from '../utils';
import { STATE_NAME } from '../constants';

import SearchRoot from '../components/SearchRoot';

const searchPromise = ({
  params,
  location: { pathname, query },
  store: { dispatch },
}) => {
  dispatch(initialize());

  const localizedKind = params.localizedKind
    ? encodeURIComponent(params.localizedKind)
    : undefined;

  const { openMap, userId } = query;

  if (openMap) {
    dispatch(toggleMobileMap());
  }

  return dispatch(getCollectionStats(localizedKind, params.location)).then(
    stats =>
      Promise.all([
        dispatch(
          load({
            ...collectionToFilters(localizedKind, stats),
            ...params,
            ...query,
            localizedKind,
          }),
        ),
        dispatch(loadHermesData(pathname)),
        userId ? dispatch(loadAdvertiser(userId)) : Promise.resolve(),
      ]),
  );
};

const mapStateToProps = state => ({
  cityCanonical: getCityCanonical(state),
  countryCode: getCountryCode(state),
  error: getErrorState(state),
  pageName: getPageName(state),
  filtersAnalytics: getAnalyticsForFilters(state),
  searchParams: getSearchParams(state),
  isAuthenticated: getIsAuthenticated(state),
  listingsAnalytics: getAnalyticsForListings(state),
  notFound: isNotFound(state),
  previewNumberOfListings: getPreviewNumberOfListings(state),
  isSuggestionBarVisible: isSuggestionBarVisible(state),
});

const mapDispatchToProps = {
  onTrackFilterApplied: trackFilterApplied,
  getFavoriteListings,
  getSearchAlert,
};

const enhance = asyncConnect(
  [{ key: STATE_NAME, promise: searchPromise }],
  mapStateToProps,
  mapDispatchToProps,
);

const SearchRootWithImageExperiment = props => (
  <Experiment name={EXPERIMENTS.HA3710.name}>
    <Variant name="A">
      <SearchRoot {...props} />
    </Variant>
    <Variant name="B">
      <SearchRoot {...props} />
    </Variant>
  </Experiment>
);

const SearchRootWithAlgoExperimentt = props => (
  <Experiment name={EXPERIMENTS.HA3873.name}>
    <Variant name="A">
      <SearchRootWithImageExperiment {...props} />
    </Variant>
    <Variant name="B">
      <SearchRootWithImageExperiment {...props} />
    </Variant>
  </Experiment>
);

export default enhance(SearchRootWithAlgoExperimentt);
